<template>
    <div
        :class="{ idle }"
        class="text-yanone"
        @mouseenter="mouseOver = true"
        @mouseleave="mouseOver = false"
    >
        <div id="summary-content" :class="{ fixed }">
            <input
                v-model="search"
                placeholder="Filtrar..."
                type="text"
                @blur="searchFocused = false"
                @focus="searchFocused = true"
            />

            <ul v-if="filteredSummary">
                <template v-for="(item, index) in filteredSummary.items">
                    <li :class="{ 'summary-margin-top': index > 0 }" class="text-uppercase">
                        <a :href="item.link">{{ item.name }}</a>
                    </li>

                    <li v-if="item.items">
                        <ul>
                            <li v-for="subItem in item.items">
                                <a :href="subItem.link">{{ subItem.name }}</a>
                            </li>
                        </ul>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'GuideSummary',

        props: {
            summary: Object,
        },

        data() {
            return {
                searchFocused: false,
                mouseOver: false,
                search: '',
                fixed: false,
                filteredSummary: {},
            };
        },

        mounted() {
            this.filter();
            this.listenScroll();
        },

        watch: {
            search() {
                this.onSearch();
            },
            summary() {
                this.onSearch();
            },
        },

        computed: {
            idle() {
                return !this.mouseOver && !this.searchFocused;
            },
        },

        methods: {
            filter(item) {
                const compareItemName = (item) => {
                    return item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
                };

                if (!item) return;

                if (!item.items) {
                    return compareItemName(item) ? item : null;
                } else {
                    const filteredItem = { items: [] };

                    for (const subItem of item.items) {
                        const filteredSubItem = this.filter(subItem);

                        if (filteredSubItem) {
                            filteredItem.items.push(filteredSubItem);
                        }
                    }

                    if (filteredItem.items.length > 0 || compareItemName(item)) {
                        for (const prop in item) {
                            if (prop !== 'items' && item.hasOwnProperty(prop)) {
                                filteredItem[prop] = item[prop];
                            }
                        }

                        return filteredItem;
                    } else return null;
                }
            },

            onSearch() {
                this.filteredSummary = this.filter(this.summary);
            },

            listenScroll() {
                window.addEventListener(
                    'scroll',
                    () => {
                        const scroll =
                            document.body.scrollTop || document.documentElement.scrollTop;

                        this.fixed = scroll >= 48;
                    },
                    { passive: true }
                );
            },
        },
    };
</script>